import Tabs from "../../components/common/Tabs";
import { AdminProfileTabs } from "../../utils/constants";
import AdminSidebarToggle from "../../components/Admin/AdminSidebarToggle";

const Profile = () => {
  return (
    <section>
      <div className="flex items-center mb-4">
        <Tabs tabs={AdminProfileTabs} prefix={<AdminSidebarToggle />} />
      </div>
    </section>
  );
};

export default Profile;
